import React, { useState } from "react";
import PropTypes from "prop-types";
import { Collapse, FormControlLabel } from "@mui/material";

// import SearchInput from "./SearchInput";
import FilterInput from "./FilterInput";
import FilterDatePicker from "./FilterDatePicker";
import FilterLabel from "./FilterLabel";
import Switch from "../Switch";
import ExportSheetAction from "../../containers/Admin-portal/Events/ViewEventV2/ApplicantsTab/ExportFormat";
import { UIButton, UISearchField } from "../ui";
import { clx, convertHtmlToText } from "../../utils/Helpers";

import "./_Filter.scss";

const Filters = ({
  searchInput,
  filters,
  isCollapsable,
  hideFilterToggle,
  renderActionNextToSearch,
  renderActionBeforeFilterToggle,
  csvFile,
  handleExport,
  csvBtnName,
  isShowSearch,
  exportSheetData,
  eventName,
  handleExportAll,
  event,
  onExportComplete,
  classNames,
  defaultExpanded,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultExpanded);
  const resolvedSearchPlaceholder =
    typeof searchInput?.placeholder === "string"
      ? searchInput.placeholder
      : searchInput?.placeholder?.label || "";
  const resolvedSearchValue =
    typeof searchInput?.value === "string" ? searchInput.value : "";
  const handleSearchValueChange = (value) => {
    searchInput?.onChange?.(typeof value === "string" ? value : "");
  };

  const renderSearch = () => (
    <div className="filter-section-container__search-row d-flex align-items-center gap-3">
      {isShowSearch && (
        <UISearchField
          placeholder={resolvedSearchPlaceholder}
          name={searchInput.name}
          value={resolvedSearchValue}
          onValueChange={handleSearchValueChange}
        />
      )}
      {renderActionNextToSearch}
    </div>
  );

  const renderFilter = ({
    type,
    name,
    placeholder,
    label,
    value,
    onChange,
    options,
    wrapperClass,
    inputClass,
    disabled,
    isMultiple,
    helperText,
    helperTextClass,
    calendarViews,
    openView,
    inputDateFormat,
    clearfilters,
    isOptionsElt,
    showOptionTooltip,
    loading,
    inputValue,
    onInputChange,
    onOpen,
    filterOptions,
    render,
    isInputHasErr,
    errMsg,
    showLabel,
    disableFuture,
  }) =>
    type === "filter" ? (
      <FilterInput
        name={name}
        placeholder={placeholder}
        label={label}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        isMultiple={isMultiple}
        filterWrapperClass={wrapperClass}
        inputClassName={inputClass}
        helperText={helperText}
        helperTextClass={helperTextClass}
        isOptionsElt={isOptionsElt}
        showOptionTooltip={showOptionTooltip}
        loading={loading}
        inputValue={inputValue}
        onInputChange={onInputChange}
        onOpen={onOpen}
        filterOptions={filterOptions}
        showLabel={showLabel}
      />
    ) : type === "component" ? (
      render?.() || null
    ) : type === "date" ? (
      <FilterDatePicker
        name={name}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        wrapperClass={wrapperClass}
        inputClass={`w-100 ${inputClass}`}
        helperText={helperText}
        helperTextClass={helperTextClass}
        calendarViews={calendarViews}
        openView={openView}
        inputDateFormat={inputDateFormat}
        clear={clearfilters}
        isInputHasErr={isInputHasErr}
        errMsg={errMsg}
        showLabel={showLabel}
        disableFuture={disableFuture}
      />
    ) : type === "switch" ? (
      <FormControlLabel
        control={<Switch name={name} checked={value} onChange={onChange} />}
        label={label}
        labelPlacement="start"
      />
    ) : null;
  return (
    <div className={clx("filter-section-container", classNames.container)}>
      {filters.length >= 3 || isCollapsable ? (
        <>
          <div className={clx("filter-section-container__base d-flex align-items-center justify-content-between flex-column flex-md-row", classNames?.base)}>
            <div className={convertHtmlToText("search-section", classNames.search)}>{renderSearch()}</div>
            <div className="filter-section-container__actions d-flex align-items-center gap-3">
              {renderActionBeforeFilterToggle}
              {csvFile && (
                <>
                  <ExportSheetAction
                    handleExportModal={handleExport}
                    exportData={exportSheetData}
                    eventName={eventName}
                    handleExportAll={handleExportAll}
                    event={event}
                    onExportComplete={onExportComplete}
                  />
                  <UIButton
                    onClick={() => handleExport()}
                    variant="outlined"
                    size="large"
                  >
                    {csvBtnName}
                  </UIButton>
                </>
              )}
              {hideFilterToggle ? null : (
                <FilterLabel onClick={() => setIsCollapsed(!isCollapsed)} />
              )}
            </div>
          </div>
          <div
            className={clx(
              "max-filters-container",
              isCollapsed && "max-filters-container--expanded",
            )}
          >
            <Collapse direction="up" in={isCollapsed}>
              <div className="row max-filters-container__row">
                {filters &&
                  filters.map(
                    (filter, index) =>
                      filter && (
                        <div
                          key={filter.name ?? index}
                          className={clx("col-12 col-sm-6 col-md-4 col-lg-3", filter.className, classNames.filter)}
                        >
                          {renderFilter(filter)}
                        </div>
                      )
                  )}
              </div>
            </Collapse>
          </div>
        </>
      ) : (
        <>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className={clx("search-section", classNames.search)}>
                {renderSearch()}
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="min-filters-container row justify-content-end">
                {filters &&
                <div className="row">
                  {
                  filters.map(
                    (filter, index) =>
                      filter && (
                        <div
                          key={filter.name ?? index}
                          className={clx("col-12 col-md-6 mb-3", classNames.filter)}
                        >
                          {renderFilter(filter)}
                        </div>
                      )
                  )}
                </div>
                }
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

Filters.propTypes = {
  searchInput: PropTypes.shape({
    placeholder: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    inputWrapperClass: PropTypes.string,
  }),
  isShowSearch: PropTypes.bool,
  filters: PropTypes.array,
  isCollapsable: PropTypes.bool,
  hideFilterToggle: PropTypes.bool,
  renderActionNextToSearch: PropTypes.element,
  renderActionBeforeFilterToggle: PropTypes.element,
  csvFile: PropTypes.bool,
  handleExport: PropTypes.func,
  csvBtnName: PropTypes.string,
  exportSheetData: PropTypes.arrayOf(PropTypes.object),
  eventName: PropTypes.string,
  handleExportAll: PropTypes.func,
  event: PropTypes.object,
  onExportComplete: PropTypes.func,
  classNames: PropTypes.object,
  defaultExpanded: PropTypes.bool,
};

Filters.defaultProps = {
  isShowSearch: true,
  defaultExpanded: false,
  hideFilterToggle: false,
  classNames: {
    base: "mb-3",
    search: "mb-3 mb-md-0",
    filter: "",
    container: "",
  },
};

export default Filters;
